import axios from "axios";
import JwtService from "@/common/JwtService";
import LocalStorageService from "@/common/LocalStorageService";
import { FORCE_LOGOUT } from "@/store/constants/actions.type";
import { PUBLISH_INSTANCE, AUTH_INSTANCE } from "./constants";
import { LOGIN } from "@/router/names.type";
import router from "@/router";
import store from "@/store";
import qs from "qs";

class Instance {
  constructor(baseURL, timeout = null) {
    this.instance = axios.create({
      baseURL: baseURL,
      timeout
    });
    this.instance.CancelToken = axios.CancelToken;
    this.instance.isCancel = axios.isCancel;

    if (baseURL != PUBLISH_INSTANCE && baseURL != AUTH_INSTANCE) {
      this.instance.interceptors.request.use(this.reqInterceptors);
      this.instance.interceptors.response.use(
        response => response,
        this.resInterceptors.bind(this)
      );
    }
  }

  reqInterceptors(config) {
    const token = JwtService.getToken();
    const username = LocalStorageService.getUsername();
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    if (!config.headers.username) {
      config.headers.username = username ? username : "";
    }
    return config;
  }

  resInterceptors(error) {
    const { response } = error;

    if (response?.status === 401) this.logout();
    return Promise.reject(error);
  }

  logout() {
    store.dispatch(FORCE_LOGOUT).then(() => {
      const loginpath = window.location.pathname;
      const loginsearch = window.location.search;
      router.replace({
        name: LOGIN,
        query: { pathname: loginpath, search: loginsearch }
      });
      setTimeout(function() {
        store.commit("snackbar/setSnack", {
          show: true,
          message: "Token Expired. Sorry you must login again",
          color: "error"
        });
      }, 500);
    });
  }

  async query(resource, params) {
    return this.instance.get(resource, params);
  }

  async queryArray(resource, { params, cancelToken }) {
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });
    return this.instance.get(resource, {
      params,
      cancelToken,
      paramsSerializer: parameter => qs.stringify(parameter, { indices: false })
    });
  }

  async download(resource, params, type) {
    return this.instance.get(resource, { params, responseType: type });
  }

  async fetch(resource, slug = "", params = null) {
    return this.instance.get(`${resource}/${slug}`, params);
  }

  async post(resource, params, config) {
    return this.instance.post(`${resource}`, params, config);
  }

  async create(resource, slug = "", params = null, config = null) {
    return this.instance.post(`${resource}/${slug}`, params, config);
  }

  async update(resource, slug, params) {
    return this.instance.put(`${resource}/${slug}`, params);
  }

  async put(resource, params, config) {
    return this.instance.put(`${resource}`, params, config);
  }

  async delete(resource, config) {
    return this.instance.delete(resource, config);
  }

  async deleteSlug(resource, slug, config) {
    return this.instance.delete(`${resource}/${slug}`, config);
  }

  cancelRequest() {
    return this.instance.CancelToken;
  }
}

export default Instance;
